import React from 'react';
import styled from 'styled-components';
import {
  Select as MUISelect,
  FormControl,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { InfoCircle } from 'components/shared/InfoCircle';

const StyledFormControl = styled(FormControl)`
  margin-top: 8px;
  min-width: 100%;
  .MuiInputBase-root {
    font-family: 'Whitney Book';
  }

  &:focus-visible {
    outline: none;
  }

  &&&&& .MuiOutlinedInput-notchedOutline {
    border-color: #888888;
    border-radius: 0;
  }

  &&&&&&&&&& .Mui-error {
    .MuiOutlinedInput-notchedOutline {
      border-color: #bf1e2d;
    }
  }

  &&&&&&&&&& .Mui-disabled {
    fieldset {
      border: 1px solid #a6a6a6 !important;
      color: #888888;
    }
  }

  .MuiFormHelperText-root.Mui-error,
  .error-text {
    color: #bf1e2d;
    font-family: Whitney Medium;
    font-size: 13px;
    margin-left: 0;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: none;
  }
`;

const StyledLabel = styled(InputLabel)`
  &&&&&& {
    color: #000;
    min-width: fit-content;
    transform: none;

    img {
      pointer-events: auto;
    }
  }
`;

export function Select({
  value,
  label,
  error,
  id,
  name,
  required,
  errorMessage,
  options,
  disabled,
  multiple,
  needsDefaultOption,
  infoText,
  tooltipClassName,
  onBlur = () => {},
  onChange = () => {},
  onMouseOut = () => {},
  placeholder,
}) {
  if (needsDefaultOption && options[0] && options[0].value !== '') {
    options.unshift({ value: '', label: '' });
  }

  if (placeholder && options[0] && options[0].value !== '') {
    options.unshift({ value: '', label: placeholder });
  }

  return (
    <StyledFormControl variant="outlined">
      {label && (
        <StyledLabel htmlFor={id} className={disabled && 'disabled'}>
          {label}
          {!required && ' (optional)'}
          {infoText && (
            <InfoCircle
              clickable
              id={id}
              text={infoText}
              tooltipClassName={tooltipClassName}
            />
          )}
        </StyledLabel>
      )}
      <MUISelect
        id={id}
        name={name}
        multiple={multiple}
        native
        value={value}
        onChange={onChange}
        error={errorMessage}
        disabled={disabled}
        inputProps={{
          classes: { select: 'outlined-select' },
          onBlur: onBlur,
          onMouseOut: () => onMouseOut(),
        }}
        IconComponent={ExpandMoreIcon}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </MUISelect>
      {errorMessage && (
        <FormHelperText className="error-text">{errorMessage}</FormHelperText>
      )}
    </StyledFormControl>
  );
}
